import React from "react";

const IconCheck = () => {
  return <span style={{ fontFamily: "Helvetica" }}>√</span>;
};

export default IconCheck;
